import jwt from '@/auth/jwt/useJwt'

export default function Permissions() {
  const route = 'permissions'

  const indexRequest = (userId, orgId, params) => jwt.axiosIns.get(`${route}/${userId}/${orgId}`, { params }).then(res => res).catch(() => [])

  return {
    indexRequest,
  }
}
